function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
    )
  );
}

const trapFocusHandlers = {};
const warningTime = 3000;

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });

  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });

  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }

  return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function extractContent(string) {
  var div = document.createElement("div");
  div.innerHTML = string;

  return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];

    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");

    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");

    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);

    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");

      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.getCart = function (callback) {
  $.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.onCartUpdate = function (cart) {
  alert("There are now " + cart.item_count + " items in the cart.");
};

Shopify.changeItem = function (variant_id, quantity, index, callback) {
  getCartUpdate(index, quantity, callback);
};

Shopify.removeItem = function (variant_id, index, callback) {
  getCartUpdate(index, 0, callback);
};

function getCartUpdate(line, quantity, callback) {
  const body = JSON.stringify({
    line,
    quantity,
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      if (parsedState.errors) {
        showWarning("Error : " + parsedState.errors, warningTime);
        return;
      }

      if (typeof callback === "function") {
        callback(parsedState);
      } else {
        Shopify.onCartUpdate(parsedState);
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

Shopify.addItem = function (
  variant_id,
  quantity,
  $target,
  callback,
  input = null
) {
  var quantity = quantity || 1;
  let dataForm = "quantity=" + quantity + "&id=" + variant_id;

  if ($target.closest("form")) {
    const $thisForm = $target.closest("form");
    const $properties = $thisForm.find('[name^="properties"]');
    if ($properties.length)
      $properties.each((index, element) => {
        dataForm = `${dataForm}&${$(element).attr("name")}=${$(element).val()}`;
      });
  }

  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: dataForm,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      var message = window.cartStrings.addProductOutQuantity2;
      if (input.length > 0) {
        var maxValue = parseInt(input.attr("data-inventory-quantity"));
        message = getInputMessage(maxValue);
        input.val(maxValue);
      }

      Shopify.onError(XMLHttpRequest, textStatus, message);
      target?.classList.remove("is-loading");
    },
  };
  $.ajax(params);
};

Shopify.onItemAdded = function (line_item) {
  alert(line_item.title + " was added to your shopping cart.");
};

Shopify.onError = function (XMLHttpRequest, textStatus, message) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    !!data.description
      ? showWarning(data.description)
      : showWarning(data.message + ": " + message, warningTime);
  } else {
    showWarning("Error : " + message, warningTime);
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");

      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove("overflow-hidden-mobile");
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class UpdateQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeCart = false;
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll(".btn-quantity").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const $target = event.target;
    let el_input = $target.parentElement.querySelector(".quantity");
    const value = Number(el_input.value);
    const inStockNumber = Number(el_input.dataset.inventoryQuantity);
    const buttonAdd = $target
      .closest(".product-form")
      ?.querySelector("[data-btn-addtocart]");
    let newVal,
      checkAvailabel = false;

    const policyArray = document.body.matches(".quickshop-popup-show")
      ? window[`quick_shop_policy_array_${this.input.dataset.product}`]
      : window[`cart_selling_array_${this.dataset.product}`],
      currentId = document.body.matches(".quickshop-popup-show")
        ? this.closest(".productView-options").querySelector('[name="id"]')
          .value
        : this.input.dataset.cartQuantityId,
      thisVariantStatus = policyArray[currentId];

    buttonAdd?.dataset.available == "false" ||
      buttonAdd?.dataset.available == undefined
      ? (checkAvailabel = true)
      : (checkAvailabel = false);

    if ($target.matches(".plus")) newVal = value + 1;
    else if ($target.matches(".minus")) newVal = value - 1;
    else newVal = value;

    if (newVal < 0) newVal = 1;

    if (
      newVal > inStockNumber &&
      checkAvailabel &&
      thisVariantStatus == "deny"
    ) {
      const message = getInputMessage(inStockNumber);
      showWarning(message, warningTime);
      newVal = inStockNumber;
    }

    el_input.value = newVal;

    if (typeof this.changeCart == "number") {
      clearTimeout(this.changeCart);
    }
    this.changeCart = setTimeout(() => {
      if ($target.matches(".btn-quantity"))
        this.input.dispatchEvent(this.changeEvent);
    }, 350);
  }

  quantityCheckedToBeContinue() {
    const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
    return sellingArray == undefined
      ? false
      : sellingArray[
      this.querySelector('[name="quantity"]').dataset.cartQuantityId
      ] === "continue";
  }
}

class UpdateQuantityQuickShop extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll(".btn-quantity").forEach((button) =>
      button.addEventListener("click", this.onChangeQuantity.bind(this))
    );
    this.input.addEventListener("change", this.onChangeQuantity.bind(this));
  }

  onChangeQuantity(event) {
    event.preventDefault();
    const target = event.target;
    let el_input = target.parentElement.querySelector(".quantity");
    const value = Number(el_input.value);
    const inStockNumber = Number(el_input.dataset.inventoryQuantity);
    const buttonAdd = target
      .closest("[data-quickshop]")
      .querySelector("[data-btn-addtocart]");
    let newVal;

    if (target.matches(".plus")) newVal = value + 1;
    else if (target.matches(".minus")) newVal = value - 1;
    else newVal = value;

    if (newVal <= 0) newVal = 1;

    if (newVal > inStockNumber && !buttonAdd.matches(".button--pre-untrack")) {
      const message = getInputMessage(inStockNumber);
      showWarning(message, warningTime);
      newVal = inStockNumber;
    }

    el_input.value = newVal;
    if (target.matches(".btn-quantity"))
      this.input.dispatchEvent(this.changeEvent);
    const quickshop = this.closest("[data-quickshop]");
    const realQuantityInput = quickshop.querySelector(
      'form input[type="hidden"]'
    );
    realQuantityInput.setAttribute("value", newVal);
  }
}

class ProductScroller extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector("[data-drag-container]");
    this.dragParent = this.querySelector("[data-drag-parent]");

    this.initDragToScroll();
  }

  initDragToScroll() {
    const isOverflowing = (wrapper) => {
      return wrapper.clientWidth < wrapper.scrollWidth;
    };
    let containerOverflowing = isOverflowing(this.container);

    if (containerOverflowing) {
      this.dragToScroll(this.container);
      return;
    }
    this.dragToScroll(this.dragParent);
  }

  dragToScroll(slider) {
    let mouseDown = false;
    let start;
    let scrollLeft;
    let inactiveTimeout;

    slider.addEventListener("mousedown", (e) => {
      const target = e.target;

      mouseDown = true;
      start = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseup", () => {
      mouseDown = false;

      clearTimeout(inactiveTimeout);
      inactiveTimeout = setTimeout(() => {
        slider.classList.remove("active");
      }, 150);
    });

    slider.addEventListener("mousemove", (e) => {
      if (!mouseDown) return;
      e.preventDefault();

      if (!slider.classList.contains("active")) {
        slider.classList.add("active");
      }

      const x = e.pageX - slider.offsetLeft;
      const walk = (x - start) * 1;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener("mouseleave", () => {
      mouseDown = false;

      clearTimeout(inactiveTimeout);
      inactiveTimeout = setTimeout(() => {
        slider.classList.remove("active");
      }, 150);
    });
  }
}

class ImageToFlip extends HTMLElement {
  constructor() {
    super();

    this.imageContainer = this;
    this.initObserver();
  }

  initObserver() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        const imageRef = entries[0];

        if (imageRef.isIntersecting) {
          imageRef.target.classList.add("show");
          observer.unobserve(imageRef.target);
        }
      },
      {
        threshold: 0.4,
      }
    );

    this.observer.observe(this.imageContainer);
  }
}

window.addEventListener("load", () => {
  customElements.define("cart-update-quantity", UpdateQuantity);
  customElements.define("quickshop-update-quantity", UpdateQuantityQuickShop);
  customElements.define("product-scroller", ProductScroller);
  // customElements.define('image-to-flip', ImageToFlip);
});

function showWarning(content, time = null) {
  if (window.warningTimeout) {
    clearTimeout(window.warningTimeout);
  }
  const warningPopupContent = document
    .getElementById("halo-warning-popup")
    .querySelector("[data-halo-warning-content]");
  warningPopupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  var message = window.cartStrings.addProductOutQuantity.replace(
    "[maxQuantity]",
    maxValue
  );
  return message;
}

class FadeInComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    const handler = (entries, observer) => {
      if (entries[0].isIntersecting) {
        this.classList.add("fade-in");

        observer.unobserve(this);
      }
    };

    const options = {
      threshold: 0.7,
    };

    this.observer = new IntersectionObserver(handler, options);
    this.observer.observe(this);
  }
}

window.addEventListener("load", () => {
  customElements.define("fade-in-component", FadeInComponent);
  this.loadScrolling();
});

window.onscroll = () => {
  this.loadScrolling();
};

function loadScrolling() {
  document.querySelectorAll("[data-scrolling]").forEach((element) => {
    element.dataset.scrolling == "vertical"
      ? this.scrollVertical(element)
      : this.scrollHorizontal(element);
  });
}

function scrollVertical(element) {
  const $thisItem = element.closest(".special-banner__item") || element,
    top = $thisItem.getBoundingClientRect().top,
    height = $thisItem.getBoundingClientRect().height,
    wdHeight = window.innerHeight,
    coefficient = element.scrollHeight / height,
    redundant = height >= wdHeight ? 0 : (wdHeight - height) / 2;

  if (top - redundant < 0 && top > height * -1)
    this.scrollTop(element, (top * -1 + redundant) * coefficient);
  else if (top - redundant >= 0) this.scrollTop(element, 0);
  else this.scrollTop(element, element.scrollHeight);
}

function scrollTop(element, scope) {
  element.scrollTo({ top: scope, behavior: "smooth" });
}

function scrollHorizontal(element) {
  const $thisFirst = element.querySelector(".scrolling-text__list--1"),
    $thisSecond = element.querySelector(".scrolling-text__list--2");

  if (!$thisFirst) return;

  const top = element.getBoundingClientRect().top,
    height = element.getBoundingClientRect().height,
    wdHeight = window.innerHeight,
    scrollWidth =
      $thisFirst.scrollWidth > window.innerWidth
        ? $thisFirst.scrollWidth - window.innerWidth
        : 0,
    contentHeight = $thisFirst.getBoundingClientRect().height * 2,
    redundant = height >= wdHeight ? 0 : (wdHeight - height) / 2,
    coefficient = scrollWidth / (height / 2 + redundant - contentHeight);

  let scope = (top * -1 + redundant) * coefficient,
    scope2 = (height / 2 - contentHeight + redundant) * coefficient - scope;

  if (top - redundant < 0 && top - contentHeight > (height * -1) / 2) {
    scope = scope * -1;
    scope2 = scope2 * -1;
  } else if (top - redundant >= 0) {
    scope = 0;
    scope2 = scrollWidth * -1;
  } else {
    scope = scrollWidth * -1;
    scope2 = 0;
  }
  $thisFirst.scrollWidth <= window.innerWidth
    ? ($thisSecond.style.justifyContent = "flex-end")
    : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
  $thisFirst.style.transform = `translateX(${scope}px)`;
  $thisSecond.style.transform = `translateX(${scope2}px)`;
}
class Easify {
  waitElement(singleSelector, container = document) {
    return new Promise((resolve) => {
      if (container.querySelector(singleSelector)) {
        return resolve(container.querySelector(singleSelector));
      }
      const observer = new MutationObserver((mutations) => {
        if (container.querySelector(singleSelector)) {
          observer.disconnect();
          resolve(container.querySelector(singleSelector));
        }
      });
      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
  waitElements(multiSelector, container = document) {
    return new Promise((resolve) => {
      if (container.querySelectorAll(multiSelector).length) {
        return resolve(container.querySelectorAll(multiSelector));
      }
      const observer = new MutationObserver((mutations) => {
        if (container.querySelectorAll(multiSelector).length) {
          observer.disconnect();
          resolve(container.querySelectorAll(multiSelector));
        }
      });
      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
  waitManyElements(selectors, container = document) {
    const promises = selectors.map((selector) =>
      this.waitElements(selector, container).then((elements) => elements)
    );
    return Promise.all(promises);
  }
  $on = (e, d, g, h, b) =>
    e.addEventListener(d, (c) => {
      for (d = e, b = c.target; b != d;)
        b.matches(g) ? h.call((d = b), c, b) : (b = b.parentNode);
    });
  editOptionsClicked(callback) {
    this.$on(
      document.body,
      "click",
      ".tpo_open-modal-button.tpo_edit-option-modal",
      () => {
        callback();
      }
    );
  }
}
class SmoothScrollMenu {
  constructor(selector) {
    this.menuItems = document.querySelectorAll(selector);
    this.attachEvents();
    this.hideMenuItemsWithoutSection();
  }

  attachEvents() {
    this.menuItems.forEach((item) => {
      const anchor = item.querySelector("a");
      if (
        anchor &&
        anchor.getAttribute("href") &&
        anchor.getAttribute("href") !== "#"
      ) {
        anchor.addEventListener("click", (event) =>
          this.handleMenuItemClick(event, anchor)
        );
      }
    });
  }

  handleMenuItemClick(event, anchor) {
    event.preventDefault();

    var targetHref = anchor.getAttribute("href");
    var shouldScroll = true;
    const location = window.location.pathname + window.location.hash;

    if (targetHref.includes("/") && location !== targetHref) {
      window.location.href = targetHref;
      shouldScroll = false;
    }

    if (shouldScroll) {
      var targetElement = document.getElementById(
        anchor.getAttribute("href")?.split("#")?.[1]
      );
      if (targetElement) {
        this.scrollToSection(targetElement);
      }
    }
  }

  scrollToSection(element) {
    this.smoothScrollTo(element);
  }

  smoothScrollTo(element) {
    window.scrollTo({
      behavior: "smooth",
      top: element.offsetTop,
    });
  }

  hideMenuItemsWithoutSection() {
    this.menuItems.forEach((item) => {
      const anchor = item.querySelector("a");
      const hash = anchor.getAttribute("href")?.split("#")?.[1];
      if (hash !== undefined && hash !== "" && !document.getElementById(hash)) {
        item.style.display = "none";
      }
    });
  }
}
class AlterEasifyDropdown extends Easify {
  // check for Easify Dropdowns and add price to option if possible (depending on regex)
  constructor(dropdownSelector, infoBlockSelector, index = null) {
    super();
    this.index = index === null ? index : parseInt(index);
    this.infoBlockSelector = infoBlockSelector;
    this.token = "[";
    this.reg = new RegExp(`${this.token.replace(/[\[\]]/g, "\\$&")}`);
    this.buttons = null;

    this.waitElements(dropdownSelector).then((dropdownElements) => {
      dropdownElements.forEach((dropdownElement, i) => {
        if (this.index === null || this.index === i) {
          this.displayOptionImage(dropdownElement);
          this.parseOptionSpan(dropdownElement);
          this.parseOptionInput(dropdownElement);
          this.addClickSelectedEvent(dropdownElement);
        }
      });
    });
  }
  parseOptionSpan(dropdownElement) {
    const spans = dropdownElement.querySelectorAll(
      "button.tpo_option-type-selection span:not(.tpo_additional-price)"
    );
    spans.forEach((span) => {
      if (this.reg.test(span.textContent)) {
        this.applyPriceToOptions(span);
      }
    });
  }
  parseOptionInput(dropdownElement) {
    const input = dropdownElement.querySelector("input.tpo_option-input");
    const curText = input.value;
    const text_split = curText.split(this.token);
    const span = document.createElement("span");
    span.innerText = text_split.at(0);
    span.classList.add("dropdown-cache");
    const exists = dropdownElement.querySelector(".dropdown-cache");
    if (exists) exists.innerText = text_split.at(0);
    else input.parentElement.prepend(span);
  }
  applyPriceToOptions(span) {
    const text_split = span.textContent.split(this.token);
    span.parentElement.querySelector(
      ".tpo_additional-price"
    ).innerText = `(${text_split
      .at(text_split.length - 1)
      .replace(/[\[\]]/g, "")})`;
    span.innerText = text_split.at(0);
  }
  addClickSelectedEvent(dropdownElement) {
    this.buttons = dropdownElement.querySelectorAll(
      "button.tpo_option-type-selection"
    );
    this.buttons.forEach((button, i) => {
      if (i === 0) button.setAttribute("data-selected", true);
      button.addEventListener(
        "click",
        this.onOptionClick.bind(this, button, dropdownElement)
      );
    });
  }
  onOptionClick(clickedBtn, dropdownElement) {
    this.displayOptionImage(dropdownElement, clickedBtn);
    this.parseOptionInput(dropdownElement);
    dropdownElement
      .querySelectorAll("button[data-selected]")
      .forEach((btn) => btn.removeAttribute("data-selected"));
    clickedBtn?.setAttribute("data-selected", true);
  }
  displayOptionImage(dropdownElement, passedClickedBtn = null) {
    const clickedBtn =
      passedClickedBtn ||
      dropdownElement.querySelector("button.tpo_option-type-selection");
    if (clickedBtn) {
      const img = clickedBtn.querySelector("img");
      const visibleInfoBlock = document.querySelector(this.infoBlockSelector);
      if (img && visibleInfoBlock && !visibleInfoBlock.querySelector("img")) {
        const link = visibleInfoBlock.querySelector("a");
        if (link) {
          const newLink = document.createElement("a");
          // clone attributes
          [...link.attributes].forEach((attr) => {
            newLink.setAttribute(
              attr.nodeName === "id" ? "data-id" : attr.nodeName,
              attr.nodeValue
            );
          });
          newLink.prepend(img.cloneNode(true));
          visibleInfoBlock.prepend(newLink);
        } else {
          visibleInfoBlock.prepend(img.cloneNode(true));
        }
      }
    }
  }
}
class AlterEasifyPacks extends Easify {
  // check for Easify Dropdowns and add price to option if possible (depending on regex)
  constructor() {
    super();
    this.infoBlockSelector = ".info-pack";
    this.imageToUpdateSelector = '[data-pack-image*="$$$"]';
    this.titleToUpdateSelector = '[data-pack-title*="$$$"]';

    // for forme empreinte inputs
    this.inputPreselectSelector =
      'input[name*="properties[PRESELECTED"]:not([disabled])';
    this.inputToselectSelector =
      'input[name*="properties[TOSELECT"]:not([disabled])';
    this.allSelectors = `.tpo_option-input-wrapper:has(${this.inputPreselectSelector}), .tpo_option-input-wrapper:has(${this.inputToselectSelector})`;
    this.imageSelector = "button.tpo_option-type-selection[data-selected] img";
    this.titleSelector =
      "button.tpo_option-type-selection[data-selected] .tpo_option_type_label";
    this.formeEmpreinteSelector =
      'input[name*="properties[Forme empreinte"], input[name*="properties[Abdruckform"], input[name*="properties[Impression shape"]';
    this.currentValue = {};
    this.observeFormeEmpreinteChanges();
    this.observeToSelectChanges();
    this.process();

    // for variant inputs
    this.inputVariantSelector = "input[data-variant-id][data-preselected]";
    this.preselectVariantSelector = `.productView-moreItem.productView-moreItem-product-variant:has(${this.inputVariantSelector})`;
    this.imageVariantSelector = `${this.inputVariantSelector}[data-preselected-image]`;
    this.titleVariantSelector = `${this.inputVariantSelector}[data-preselected-title]`;
    this.currentVariantID = null;
    this.observeVariantChanges();
    this.processVariant();
  }
  observeFormeEmpreinteChanges() {
    this.waitElements(this.formeEmpreinteSelector).then((inputElements) => {
      // Listen for change events on the input
      inputElements.forEach(inputElement => {
        inputElement.addEventListener("change", () => {
          if (inputElement.value !== this.currentValue[inputElement.name]) {
            this.currentValue[inputElement.name] = inputElement.value;
            this.process(`.tpo_option-input-wrapper:has(${this.inputPreselectSelector})`);
          }
        });
      })
    });
  }
  observeToSelectChanges() {
    this.waitElements(this.inputToselectSelector).then((inputElements) => {
      inputElements.forEach((inputElement) => {
        // Store initial value
        const observerCallback = (mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === 'data-selected-index' && this.currentValue[inputElement.name] !== inputElement.dataset.selectedIndex) {
              this.currentValue[inputElement.name] = inputElement.dataset.selectedIndex;
              this.process(`.tpo_option-input-wrapper:has(${this.inputToselectSelector})`, `button.tpo_option-type-selection:nth-of-type(${parseInt(inputElement.dataset.selectedIndex) + 1}) img`, `button.tpo_option-type-selection:nth-of-type(${parseInt(inputElement.dataset.selectedIndex) + 1}) .tpo_option_type_label`);
            }
          }
        };
        
        const observer = new MutationObserver(observerCallback);
        observer.observe(inputElement, { attributes: true, attributeOldValue: true });
      })
    });
  }
  observeVariantChanges() {
    // variant change
    this.waitElements(this.inputVariantSelector).then((inputElements) => {
      inputElements.forEach((inputElement) => {
        // Store initial value
        const params = new URLSearchParams(window.location.search);
        this.currentVariantID = params.get("variant") || null;

        // Listen for change events on the input
        inputElement.addEventListener("change", () => {
          if (inputElement.dataset.variantId !== this.currentVariantID) {
            this.currentVariantID = inputElement.dataset.variantId;
            this.processVariant();
          }
        });
      });
    });
  }
  process(selector = this.allSelectors, imageSelector = this.imageSelector, titleSelector = this.titleSelector) {
    this.waitElements(this.infoBlockSelector).then((infoPacks) => {
      infoPacks.forEach((infoPack, index) => {
        setTimeout(() => {
          infoPack.classList.add("visible");
        }, index * 200);
      });
    });
    this.waitElements(selector).then((wrappers) => {
      wrappers.forEach((wrapper) => {
        const token = this.retrieveInputToken(wrapper);
        if (!token) return;
        const image = this.retrieveImage(wrapper, imageSelector);
        const title = this.retrieveTitle(wrapper, titleSelector);
        const imagesToUpdate = this.retrieveImagesToUpdate(token);
        const titlesToUpdate = this.retrieveTitlesToUpdate(token);
        let consola = "";
        if (imagesToUpdate.length > 0) {
          consola += `image `;
          imagesToUpdate.forEach((imageToUpdate) => {
            imageToUpdate.src = image;
          });
        }
        if (titlesToUpdate.length > 0) {
          consola += `${consola ? `and ` : ""}title `;
          titlesToUpdate.forEach((titleToUpdate) => {
            titleToUpdate.innerText = title;
          });
        }
        if (consola)
          console.info("🚨", `${consola}updated for token '${token}'`, "🚨");
        if (consola)
          console.info(
            "⌙",
            token,
            image,
            title,
            imagesToUpdate,
            titlesToUpdate,
            "🚨"
          );
        else
          console.warn(
            "⚠️",
            token,
            image,
            title,
            imagesToUpdate,
            titlesToUpdate,
            "⚠️"
          );
      });
    });
  }
  processVariant() {
    this.waitElements(this.allSelectors).then(() => {
      this.waitElement(this.preselectVariantSelector).then(
        (preselectWrapper) => {
          // Move preselectWrapper element after infoBlockSelector
          const infoBlock = document.querySelector(this.infoBlockSelector);
          if (infoBlock && preselectWrapper) {
            const infoBlockParent = infoBlock?.parentElement?.parentElement;
            if (infoBlockParent) {
              infoBlockParent.insertAdjacentElement(
                "afterend",
                preselectWrapper
              );
            }
          }
          const token = this.retrieveVariantToken(preselectWrapper);
          if (!token) return;
          const image = this.retrieveVariantImage(preselectWrapper);
          const title = this.retrieveVariantTitle(preselectWrapper);
          const imagesToUpdate = this.retrieveImagesToUpdate(token);
          const titlesToUpdate = this.retrieveTitlesToUpdate(token);
          let consola = "";
          if (imagesToUpdate.length > 0 && image) {
            consola += `image `;
            imagesToUpdate.forEach((imageToUpdate) => {
              imageToUpdate.src = image;
            });
          }
          if (titlesToUpdate.length > 0 && title) {
            consola += `${consola ? `and ` : ""}title `;
            titlesToUpdate.forEach((titleToUpdate) => {
              const current = titleToUpdate.innerText;
              const variantTitle = ` (${title})`;
              if (!current.includes(variantTitle)) {
                if (current.includes(" ("))
                  titleToUpdate.innerText = `${current.split(" (")[0]
                    }${variantTitle}`;
                else titleToUpdate.innerText = `${current}${variantTitle}`;
              }
            });
          }
          if (consola)
            console.info("🚨", `${consola}updated for token '${token}'`, "🚨");
          if (consola)
            console.info(
              "⌙",
              token,
              image,
              title,
              imagesToUpdate,
              titlesToUpdate,
              "🚨"
            );
          else
            console.warn(
              "⚠️",
              token,
              image,
              title,
              imagesToUpdate,
              titlesToUpdate,
              "⚠️"
            );
        }
      );
    });
  }
  retrieveInputToken(wrapper) {
    // example : properties[PRESELECTED-PRESS] or properties[TOSELECT-PRESS] 
    const input = wrapper?.querySelector('input[name*="properties["]');
    return input?.name?.match(/PRESELECTED-(.+?)\]/)?.[1] || input?.name?.match(/TOSELECT-(.+?)\]/)?.[1];
  }
  retrieveVariantToken(preselectWrapper) {
    const globalWrapper = preselectWrapper?.querySelector(
      this.inputVariantSelector
    );
    return globalWrapper?.dataset?.preselected;
  }
  retrieveImagesToUpdate(token) {
    return document.querySelectorAll(
      this.imageToUpdateSelector.replace("$$$", token)
    );
  }
  retrieveTitlesToUpdate(token) {
    return document.querySelectorAll(
      this.titleToUpdateSelector.replace("$$$", token)
    );
  }
  retrieveImage(wrapper, selector) {
    return wrapper?.querySelector(selector)?.src;
  }
  retrieveTitle(wrapper, selector) {
    return wrapper?.querySelector(selector)?.innerText;
  }
  retrieveVariantImage(wrapper) {
    return wrapper?.querySelector(
      `${this.imageVariantSelector}[data-variant-id="${this.currentVariantID}"]`
    )?.dataset?.preselectedImage;
  }
  retrieveVariantTitle(wrapper) {
    return wrapper?.querySelector(
      `${this.titleVariantSelector}[data-variant-id="${this.currentVariantID}"]`
    )?.dataset?.preselectedTitle;
  }
}
class ProductTypeSwitcher extends Easify {
  // allow to re-trigger AlterEasifyDropdown on product type switch
  constructor(buttonSwitchSelector) {
    super();
    this.process(buttonSwitchSelector);
  }
  process(buttonSwitchSelector) {
    this.waitElements(buttonSwitchSelector).then((radioButtons) => {
      radioButtons.forEach((radioButton) => {
        const applyFn = () => {
          const index = radioButton.querySelector("input").id.split("-").at(-1);
          new AlterEasifyDropdown(
            '.tpo_option-container[id$=",dropdown"]',
            '.tpo_option-container[id$=",html"]:not(.tpo_hidden) .tpo_option-html .info-product',
            index
          );
        };
        radioButton.addEventListener("click", applyFn.bind(this));
      });
    });
  }
}
class AlterEasifyProductPrice extends Easify {
  // alter Easify product price to add a /unit after when necessary
  constructor(inputSelector, buttonsQuantitySelector, priceLabelSelector) {
    super();
    this.inputElement = null;
    this.buttonsQuantityElements = null;
    this.labelElement = null;
    this.waitManyElements([
      inputSelector,
      buttonsQuantitySelector,
      priceLabelSelector,
    ]).then(([inputElement, buttonsQuantityElements, labelElement]) => {
      this.inputElement = inputElement[0];
      this.buttonsQuantityElements = buttonsQuantityElements;
      this.labelElement = labelElement[0];
      this.applyUnityOnQuantity();
    });
  }
  applyUnityOnQuantity() {
    const applyFn = () => {
      const quantity = this.inputElement.value;
      const labelWrapper = this.labelElement.parentElement;
      const unitySpan = labelWrapper.querySelector(".quantity-unity-label");
      if (quantity > 1) {
        if (!unitySpan) {
          const unityNewSpan = document.createElement("span");
          unityNewSpan.classList.add("quantity-unity-label", "price-item");
          unityNewSpan.innerHTML =
            popstampStore.easifyTranslate["general.common.unit"];
          labelWrapper.appendChild(unityNewSpan);
        }
      } else if (unitySpan) {
        labelWrapper.removeChild(unitySpan);
      }
    };
    applyFn();
    this.buttonsQuantityElements.forEach((buttonQuantityElement) => {
      buttonQuantityElement.addEventListener("click", applyFn.bind(this));
    });
    this.inputElement.addEventListener("input", applyFn);
  }
}
class AlterEasifyModals extends Easify {
  // alter Easify modals to handle inner buttons with cancel options
  constructor(modalSelector) {
    super();
    this.buttonCloseData = "data-button-modals-close";
    this.buttons = [];
    this.modals = [];

    this.waitElements(`[${this.buttonCloseData}]`).then((buttons) => {
      buttons.forEach((buttonClose, i) => {
        buttonClose.addEventListener("click", this.closePopup.bind(this, i));
        this.buttons.push(buttonClose);
        this.modals.push(buttonClose.closest(modalSelector));
      });
    });
  }
  closePopup(index) {
    const isOpened = this.modals[index].style.display === "block";
    if (isOpened) this.modals[index].style.display = "none";
  }
}
class AlterEasifyHTMLTranslation extends Easify {
  constructor() {
    super();
    this.dataSelector = `[data-easify-translate]`;
    if (
      Object.keys(popstampStore.easifyTranslate).length
    ) {
      this.translateHTML();
    }
  }
  translateHTML() {
    const translations = popstampStore.easifyTranslate;
    this.waitElements(this.dataSelector).then((elements) => {
      if (elements.length) {
        elements.forEach((element) => {
          const key = element.dataset["easifyTranslate"];
          if (key in translations && (!popstampStore?.langDefault || element.innerHTML === '')) {
            element.innerHTML = translations[key];
          }
        });
      }
    });
  }
}
class AddCustomModals extends Easify {
  // alter Easify modals to handle inner buttons with cancel options
  constructor(openModalsButtonSelector) {
    super();
    if (location.pathname.includes("/cart")) {
      this.editOptionsClicked(
        this.process.bind(this, openModalsButtonSelector)
      );
    } else {
      this.process(openModalsButtonSelector);
    }
  }
  process(openModalsButtonSelector) {
    this.waitElements(openModalsButtonSelector).then((openModalsButtons) => {
      openModalsButtons.forEach((openModalButton) => {
        const modalID = openModalButton.dataset?.modalOpen;
        const $modal = document.querySelector(`[data-modal="${modalID}"]`);
        const closeModalButtons = $modal.querySelectorAll("[data-modal-close]");
        openModalButton.addEventListener("click", (e) =>
          this.openModal(e, $modal)
        );
        $modal.addEventListener("click", (e) =>
          this.closeModal(e, $modal, true)
        );
        closeModalButtons.forEach((closeModalButton) => {
          closeModalButton.addEventListener("click", (e) =>
            this.closeModal(e, $modal)
          );
        });
      });
    });
  }
  openModal(e, $modal) {
    $modal.setAttribute("data-modal-opened", null);
  }
  closeModal(e, $modal, modalBackground = false) {
    if ((e?.target === $modal && !!modalBackground) || !modalBackground)
      $modal.removeAttribute("data-modal-opened");
  }
}
class AddLinkToTab extends Easify {
  constructor(openTabSelector) {
    super();
    if (popstampStore?.lang) this.process(openTabSelector);
  }
  process(openTabSelector) {
    this.waitElement(openTabSelector).then((openTabButton) => {
      const targets = JSON.parse(openTabButton.dataset?.tabTargets);
      openTabButton.addEventListener("click", (e) =>
        this.gotoToTab(e, targets)
      );
    });
  }
  gotoToTab(e, targets) {
    if (popstampStore.lang in targets) {
      const tabID = targets[popstampStore.lang];
      const $tab = document.querySelector(`.tab-content#${tabID}`);
      if ($tab) {
        const $toggler = $tab.querySelector(".toggleLink");
        const top = parseInt($tab.getBoundingClientRect().top) - 30;
        window.scrollTo({ top, behavior: "smooth" });
        if (!$toggler.classList.contains("is-open")) $toggler.click();
      } else {
        console.error(
          "tab doesn't exist :",
          tabID,
          `document.querySelector(.tab-content#${tabID})`
        );
      }
    }
  }
}
class AlterSchemaOrgPrices extends Easify {
  // alter Easify modals to handle inner buttons with cancel options
  constructor(priceSelector) {
    super();
    this.waitElement(priceSelector).then((priceElement) => {
      const price = priceElement.textContent.replace(",", ".").slice(0, -1);
      const scripts = document.querySelectorAll('[type="application/ld+json"]');
      scripts.forEach((script) => {
        const obj = JSON.parse(script.firstChild.nodeValue);
        if ("@type" in obj && obj["@type"] === "Product" && "offers" in obj) {
          if (Array.isArray(obj.offers)) {
            obj.offers.forEach((offer) => {
              offer.price = price;
            });
          } else {
            obj.offers.price = price;
          }
          script.firstChild.nodeValue = JSON.stringify(obj);
        }
      });
    });
  }
}
class AlterCustomTextInputs extends Easify {
  // alter Easify modals to handle inner buttons with cancel options
  constructor() {
    super();
    this.defaultLabel = window.customTextDefaultLabel;
    this.noTextLabel = window.noTextLabel;
    this.confirmEmptyTextMessage = window.confirmEmptyTextMessage;
    this.defaultNoTextValue = '❌';
    this.buttonAddToCartSelector = '[data-btn-addtocart]';
    this.inputsSelector = `[placeholder*="text_custom"],[name*="properties[${this.defaultLabel}"]`;
    this.maxMetafields = 4;
    this.needsConfirmation = false;
    this.inputs = [];

    if (location.pathname.includes("/cart")) {
      this.$on(
        document.body,
        "click",
        ".tpo_open-modal-button.tpo_edit-option-modal",
        (evt, button) => {
          const cartItem = button.closest(".cart-item[data-line]");
          const cartItemKey = cartItem.dataset.line;
          this.processInCart(cartItemKey);
        }
      );
    } else {
      this.nbInputs = Array.from(
        { length: this.maxMetafields },
        (_, i) => window[`custom_text_${i + 1}`]
      ).filter(Boolean).length;
      this.process();
      if (this.nbInputs > 0) {
        document.querySelector(this.buttonAddToCartSelector)?.addEventListener('click', (e) => {
          this.prepareForCart(e);
        }, true); 
      }
    }
  }
  processInCart(cartItemKey) {
    if (cartItemKey) {
      const sidePanelSelector =
        ".tpo_modal-background.tpo_edit-option-modal .tpo_modal-container";
      const sidePanel = document.querySelector(sidePanelSelector);
      if (
        sidePanel &&
        window.custom_texts &&
        window.custom_texts[cartItemKey]
      ) {
        this.nbInputs = Object.keys(window.custom_texts[cartItemKey]).length;
        this.process(sidePanel, cartItemKey);
      }
    }
  }
  process(container = document, itemKey) {
    this.waitElements(this.inputsSelector, container).then((inputs) => {
      inputs.forEach((input, i) => {
        const index = i + 1;
        const metafieldContent =
          (itemKey && window.custom_texts?.[itemKey]?.[index]) ||
          window[`custom_text_${index}`];
        this.prepareInput(input, index, input.value || metafieldContent);
      });
    });
  }
  prepareForCart(e) {
    this.inputs?.slice(0, this.nbInputs)?.forEach((input) => {
      if (input.value === input.getAttribute('data-default-value')) {
        input.setAttribute( 'data-needs-confirmation', true );
      } else if (input.value === '') {
        input.setAttribute( 'data-field-is-empty', true );
      }
    });
    this.needsConfirmation = this.inputs?.slice(0, this.nbInputs)?.every((input) => input.hasAttribute('data-needs-confirmation')) || this.inputs?.slice(0, this.nbInputs)?.every((input) => input.hasAttribute('data-field-is-empty'));
    if (this.needsConfirmation) {
      if (!window.confirm(this.confirmEmptyTextMessage)) {
        e.preventDefault();
        e.stopPropagation();
        this.needsConfirmation = false;
        return false;
      }
    }
    this.inputs?.slice(0, this.nbInputs)?.forEach((input) => {
      if (input.hasAttribute('data-field-is-empty')) input.value = this.defaultNoTextValue
    });
  }
  prepareInput(input, index, value) {
    const wrapper = input.parentNode.parentNode.parentNode;
    this.inputs.push(input);
    if (value) {
      input.value = value;  
      input.setAttribute("data-default-value", value);
    } else if (index > 1) {
      wrapper.style.display = "none";
    }
    input.addEventListener('change', (e) => {
      input.removeAttribute( 'data-needs-confirmation' );
      input.removeAttribute( 'data-field-is-empty' );
      this.needsConfirmation = false;
    });
    input.setAttribute("placeholder", this.noTextLabel);
    if (index === 1 && this.nbInputs <= 1) {
      const label = wrapper.querySelector(".form__label");
      label.innerText = this.defaultLabel;
    }
    if (
      (index === 1 && this.nbInputs <= 1) ||
      (index === 3 && this.nbInputs === 3)
    ) {
      wrapper.classList.remove("tpo_flex-50");
      wrapper.classList.add("tpo_flex-100");
    }
  }
}
class ModelesImageSwitcher {
  constructor() {
    if (document.querySelector("[data-image-switcher]")) {
      this.imageSwitcher = document.querySelector("[data-image-switcher]");
      this.imagesToSwitch = document.querySelectorAll(
        "[data-images-to-switch]"
      );
      this.imageSwitcher
        .querySelectorAll("[data-image-switcher-button]")
        .forEach((switchButton) => {
          switchButton.addEventListener(
            "click",
            this.onClickSwitchButtonHandler.bind(this)
          );
        });
    }
  }
  onClickSwitchButtonHandler(event) {
    event.preventDefault();
    this.imagesToSwitch = document.querySelectorAll("[data-images-to-switch]");
    const buttonElement = event.currentTarget;
    if (!buttonElement.classList.contains("is-active")) {
      const value = buttonElement.dataset.value;
      this.imageSwitcher
        .querySelector("[data-image-switcher-button].is-active")
        .classList.remove("is-active");
      buttonElement.classList.add("is-active");

      const dataAttr = `image${value.charAt(0).toUpperCase() + value.slice(1)}`;
      this.imagesToSwitch.forEach((nodeElement) => {
        if (dataAttr === "imageVector")
          nodeElement.parentElement.parentElement.parentElement.classList.add(
            "card-media--vectored"
          );
        if (dataAttr === "imageBitmap")
          nodeElement.parentElement.parentElement.parentElement.classList.remove(
            "card-media--vectored"
          );
      });
    }
  }
}
class ModelesColorChanger extends Easify{
  constructor() {
    super();
    this.imageVectorStamps = null;
    this.vectorStamps = null;
    this.vectorStampSelector = '[data-vector-stamp]';
    this.inkpadMainInpu = null;
    this.inkpadMainInputSelector = '[name="properties[Sélection des encreurs (color)]"], [name="properties[Auswahl der Stempelkissen (Farbe)]"]';
    this.colorBgSelector = '.color-span-single';
    this.colorLabelSelector = `.tpo_shape_circle:has(${this.colorBgSelector})`;
    this.selectedColor = null;
    this.init();
  }
  init () {
    this.imageVectorStamps = document.querySelectorAll(this.vectorStampSelector);
    if (this.imageVectorStamps.length > 0) {
      if (SVGInject) SVGInject(this.imageVectorStamps);
      this.waitElement(this.inkpadMainInputSelector).then((inkpadMainInput) => {
        this.inkpadMainInput = inkpadMainInput;
        if (this.inkpadMainInput) {
          const labelSelector = document.querySelectorAll(this.colorLabelSelector);
          labelSelector.forEach((label) => {
            label.addEventListener('click', this.onColorLabelClick.bind(this, label));
          });
        }
      });
    }
  }
  onColorLabelClick (label) {
    const input = label.querySelector('input[type="checkbox"]');
    const colorBg = label.querySelector(this.colorBgSelector);
    if (colorBg && input?.checked) {
      this.selectedColor = colorBg.style.backgroundColor || null;
    } else if (!input?.checked) {
      const checkedLabel = document.querySelector(`${this.colorLabelSelector}.tpo_is_checked_swatches`);
      const checkedColorBg = checkedLabel?.querySelector(this.colorBgSelector);
      this.selectedColor = checkedColorBg?.style?.backgroundColor || null;
    }
    this.changeVectorColor();
  }
  changeVectorColor() {
    this.vectorStamps = document.querySelectorAll(this.vectorStampSelector);
    this.vectorStamps.forEach((vectorStamp) => {
        if (this.selectedColor) {
          vectorStamp.style.setProperty('--color', this.selectedColor);
        } else {
          vectorStamp.style.removeProperty('--color');
        }
      });
  }
}
class MobileProductFlip {
  constructor() {
    this.productsFlip = document.querySelectorAll(".product.product-flip");
    if (this.productsFlip.length > 0) {
      this.productsFlip.forEach((productFlip) => {
        if (productFlip) {
          productFlip.addEventListener(
            "touchstart",
            this.touchStart.bind(this, productFlip)
          );
          productFlip.addEventListener(
            "touchend",
            this.touchEnd.bind(this, productFlip)
          );
          productFlip.addEventListener(
            "touchcancel",
            this.touchEnd.bind(this, productFlip)
          );
        }
      });
    }
  }
  touchStart(productFlip, event) {
    productFlip.classList.add("long-touch");
  }
  touchEnd(productFlip, event) {
    productFlip.classList.remove("long-touch");
  }
}
class AddPopupsProcess extends Easify {
  constructor({ id, ...extraSettings }) {
    super();
    if (!id) throw new Error('Popup ID is required');
    // console.info('🚨', 'Popup Settings', id, extraSettings, '🚨');
    this.popupId = id;
    this.extraSettings = { ...extraSettings };
    this.closePopupSelector = "[data-popup-close]";
    this.minimizePopupSelector = "[data-popup-minimize]";
    this.maximizePopupSelector = "[data-popup-maximize]";
    this.overlaySelector = "[data-popup-overlay]";
    this.popupSelector = `[data-popup="${this.popupId}"]`;
    this.triggerDelay = (this.extraSettings?.delay < 500 ? undefined : this.extraSettings.delay) || 500;
    this.triggerAction = this.extraSettings?.trigger_action;
    this.triggerClickSelector = this.extraSettings?.trigger_click_selector;
    this.closePermanent = this.extraSettings?.close_permanent;
    this.minimizePermanent = this.extraSettings?.minimize_permanent;
    this.confirmation = this.extraSettings?.confirmation;
    this.resetTriggered();
    this.pageLoadTime = Date.now();
    this.cookieName = `${this.popupId.replaceAll('-', '')}PopupStatus`;

    this.process();
  }
  resetTriggered() {
    this.hasTriggered = false;
  }
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  setCookie(name, value, options = { expires: 365, path: '/' }) {
    $.cookie(name, value, options);
  }
  process() {
    this.waitElement(this.popupSelector).then((popup) => {
      const closePopupButtons = popup.querySelectorAll(this.closePopupSelector);
      if (closePopupButtons?.length > 0) closePopupButtons.forEach(button => button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const callback = () => { if (e.target.hasAttribute('href')) window.location.href = e.target.href; }
        this.closePopup(popup, false, 500, callback);
      }));
      const minimizePopupButton = popup.querySelector(this.minimizePopupSelector);
      if (minimizePopupButton) minimizePopupButton.addEventListener("click", () => this.closePopup(popup, true));
      const maximizePopupButton = popup.querySelector(this.maximizePopupSelector);
      if (maximizePopupButton) maximizePopupButton.addEventListener("click", () => this.openPopup(popup));
      const popupOverlay = document.querySelector(this.overlaySelector, popup.parentElement);
      if (popupOverlay) popupOverlay.addEventListener("click", () => this.closePopup(popup));
      if (this.triggerAction) {
        if (this.triggerAction === 'click') {
          this.waitElement(this.triggerClickSelector).then((triggerButton) => {
            if (triggerButton) triggerButton.addEventListener('click', () => this.openPopup(popup, 0));
          });
        } else if (this.triggerAction === 'on_maximize') {
          this.setCookie(this.cookieName, 'true');
        } else {
          document.addEventListener(this.triggerAction, () => this.actionTrigger(popup));
        }
      }
      else this.actionTrigger(popup, true);
    });
  }
  actionTrigger(popup, force = false) {
    if (!this.hasTriggered && this.popupConditionValid()) {
      this.triggerPopup(popup, force);
    }
  }
  triggerPopup(popup, force = false) {
    this.hasTriggered = true;

    const timeSincePageLoad = Date.now() - this.pageLoadTime;

    if (this.confirmation) {
      this.openPopup(popup, 500);

      let closeTimeout = null;

      const handleMouseEnter = () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
      };
      const handleMouseLeave = () => {
        startCloseTimer();
      };
      const startCloseTimer = () => {
        closeTimeout = setTimeout(() => {
          this.closePopup(popup);
          popup.removeEventListener('mouseenter', handleMouseEnter);
          popup.removeEventListener('mouseleave', handleMouseLeave);
        }, this.triggerDelay);
      };
      popup.addEventListener('mouseenter', handleMouseEnter);
      popup.addEventListener('mouseleave', handleMouseLeave);

      // Start the initial timer
      startCloseTimer();
    } else {
      if (timeSincePageLoad < this.triggerDelay && !force) {
        const remainingDelay = this.triggerDelay - timeSincePageLoad;
        this.openPopup(popup, remainingDelay);
      } else {
        this.openPopup(popup, this.triggerDelay);
      }
    }
  }
  openPopup(popup, delay = 0) {
    const wrapper = popup.parentElement;
    if (wrapper) wrapper.classList.add('--opened');
    const overlay = wrapper.querySelector(this.overlaySelector);
    setTimeout(() => {
      if (overlay) overlay.classList.add('--visible');
      popup.setAttribute("data-popup-opened", null);
      if (this.confirmation) this.addConfettiToPopup(popup);
    }, delay);
  }
  closePopup(popup, minimize = false, delay = 500, callback = null) {
    if ((minimize && this.minimizePermanent) || (!minimize && this.closePermanent)) this.setCookie(this.cookieName, 'true');
    if (callback && typeof callback === 'function') callback();
    const wrapper = popup.parentElement;
    const overlay = wrapper.querySelector(this.overlaySelector);
    popup.removeAttribute("data-popup-opened");
    if (overlay) overlay.classList.remove('--visible');
    setTimeout(() => {
      if (wrapper) wrapper.classList.remove('--opened');
      this.resetTriggered();
    }, delay);
  }
  popupConditionValid() {
    if (this.getCookie(this.cookieName) === 'true') return false
    if (this.confirmation) {
      // only after the form of the matching popup was submitted: closing that popup sets its PopupStatus cookie too
      const submittedCookie = this.cookieName.replace('confirmation', '').replace('PopupStatus', 'PopupSubmitted');
      if (!this.getCookie(submittedCookie)) return false
    }
    return true
  }
  // canvas-confetti is only needed when a confirmation popup opens: loaded then, once per page
  static loadConfetti() {
    if (window.confetti) return Promise.resolve(window.confetti);
    if (!AddPopupsProcess.confettiPromise) {
      AddPopupsProcess.confettiPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
        script.onload = () => resolve(window.confetti);
        script.onerror = () => {
          AddPopupsProcess.confettiPromise = null;
          reject(new Error('canvas-confetti failed to load'));
        };
        document.head.appendChild(script);
      });
    }
    return AddPopupsProcess.confettiPromise;
  }
  addConfettiToPopup(popup) {
    const canvas = popup.querySelector('.confirmation-canvas');
    if (!canvas) return;
    AddPopupsProcess.loadConfetti().then((confetti) => {
      const myConfetti = confetti.create(canvas, { resize: true });
      myConfetti({
        ticks: 200,
        particleCount: 40,
        startVelocity: 12,
        decay: 0.93,
        angle: 90,
        spread: 360,
        origin: {
          y: -0.25
        }
      });
    }).catch(() => { /* no confetti, the popup still works */ });
  }
}
class ScrollToHash {
  constructor() {
    const hash = window.location.hash;
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;
    const hashPos = parseInt(target.getBoundingClientRect().top) - 160;
    window.scrollTo({ top: hashPos, behavior: "smooth" });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  new SmoothScrollMenu(".header__inline-menu .menu-lv-1");
  // The Easify product form only exists on product pages. Each helper below waits for its element with a
  // MutationObserver on <body> that is only released once the element shows up: never, on the other pages.
  if (document.body.classList.contains("template-product")) {
    new AlterEasifyDropdown(
      '.tpo_option-container[id$=",dropdown"]',
      '.tpo_option-container[id$=",html"]:not(.tpo_hidden) .tpo_option-html .info-product'
    );
    new AlterEasifyPacks();
    new AlterEasifyProductPrice(
      ".productView-quantity input.quantity__input",
      ".productView-quantity button.btn-quantity",
      ".productView-price .tpo_product_price"
    );
    new ProductTypeSwitcher('label:has(.tpo_buttons-input[id^="Appareil"])');
    new AddLinkToTab("[data-tab-targets]");
    new AlterSchemaOrgPrices(".tpo_product_price");
  }
  new AlterEasifyModals(".tpo_modal-background");
  new AlterCustomTextInputs();
  new AlterEasifyHTMLTranslation();
  new ModelesImageSwitcher();
  new ModelesColorChanger();
  if (popstampStore.popups?.length > 0) {
    popstampStore.popups.forEach((popupSettings) => new AddPopupsProcess(popupSettings));
  }
  //   new MobileProductFlip();
  new ScrollToHash();
});
window.addEventListener("hashchange", (e) => {
  e.preventDefault();
  new ScrollToHash();
});